export default "__VITE_ASSET__BjAhmB1g__"